<script>
  import { format } from 'svelte-i18n';

  import { Banner } from '@client/components/banner';

  import { userStore } from '@client/stores/user';

  const config = {
    type: 'error',
    dismissable: true,
    position: 'top',
    header: $format('label.ACCOUNT_SUSPENDED')
  };

  $: warning = $userStore.featuresConfig?.warning?.replace(/\n/g, '<br />');
</script>

{#if $userStore.featuresConfig?.disableservice && warning}
  <Banner
    config={{
      ...config,
      text: warning
      // text: $format('label.DISABLED_SERVICE_NOTICE', { values: { invoiceUrl } }),
    }}
  />
{:else if $userStore.featuresConfig?.disableservice && !warning}
  <Banner
    config={{
      ...config,
      text: $format('label.DISABLED_SERVICE')
    }}
  />
{:else if warning}
  <Banner
    config={{
      ...config,
      text: warning,
      // text: $format('label.DISABLED_SERVICE_WARNING', { values: { invoiceUrl } }),
      type: 'warning',
      header: $format('label.ACCOUNT_SUSPENSION')
    }}
  />
{/if}
